module.exports = __webpack_public_path__ + "static/media/refresh.9c31ca85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/refresh.svg
// module id = 941
// module chunks = 5